import {
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
  Fade,
} from '@mui/material';
import { MESSAGES } from '../constants/registerPaymentConstants';

const DuplicateAlertDialog = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="duplicate-alert-title"
      aria-describedby="duplicate-alert-description"
      TransitionComponent={Fade}
      transitionDuration={400}
    >
      <DialogContent>
        <DialogContentText id="duplicate-alert-description">
          {MESSAGES.ERROR.DUPLICATE_COUPON}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          color="primary"
          sx={{
            transition: 'all 0.3s ease',
            '&:hover': {
              transform: 'scale(1.05)',
            },
          }}
        >
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DuplicateAlertDialog;
